import 'isomorphic-fetch';

import { take, takeEvery, takeLatest } from 'redux-saga/effects';
import { generateInvoicePDF } from '../routes/Account/actions';

const generateHeader = () => {
    const clientId = '585144b114a9ff076c0fe291';
    const clientSecret = '8f15b838015a1052e43342a571d63ac5';
    const base64 = window.btoa(clientId + ':' + clientSecret);
    return {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Basic ' + base64,
    };
};

export function* generateInvoicePDFWorker(action) {
    console.log(action);
}

export function* generateInvoicePDFSaga() {
    yield* take(actionName(generateInvoicePDF), generateInvoicePDFWorker);
}

export default function* sagas() {
    yield [generateInvoicePDFSaga()];
}

/**
 * Unpacks the action name of an action created with redux-act
 * @param {} action
 * @returns {}
 */
function actionName(action) {
    return action().type;
}
